var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"e-h2 e-sub-title"},[_c('span',{staticClass:"e-sub-title__back"},[_vm._t("default")],2),_c('span',{staticClass:"e-sub-title__overlay"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }